import { render } from "./Notes.vue?vue&type=template&id=ec600f00&scoped=true&ts=true&lang=html"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=ec600f00&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec600f00"]])

export default __exports__